<div class="infobox-section" [style]="'max-width:' + (maxWidth != null ? maxWidth : 'auto')">
    <div class="infobox-text">
        {{text}}
    </div>
</div>
